import { generateColumnDefs } from './generateColumnDefs';
import { checkForNestedChildren } from './helpers';

export const getDetailsCellRender = (data) => {
  const childrenDefs = generateColumnDefs(data);

  const nestedChild = checkForNestedChildren(data)?.children;

  return {
    detailGridOptions: {
      columnDefs: childrenDefs,
      masterDetail: true,
      flex: 1,
      ...(nestedChild && { detailCellRendererParams: getDetailsCellRender(nestedChild) })
    },
    getDetailRowData: (params) => {
      params.successCallback(params.data.children || []);
    }
  };
};
